import React from "react";
import classnames from "classnames";
import { browserHistory, withRouter } from "react-router";

import AppAuthStore from "../../stores/login-store";
import upgradePlans from "../../data/upgrade-plans";
import PaymentButton from "./payment-button";
import authenticationMixin from "../../mixins/authenticationMixin";
import Api from "../../api/api";
import moment from "moment";
import { ModalHeader } from "../popups/modal-parts";
import Analytics from "../../services/analytics";

class UpgradeModal extends React.Component {
  constructor() {
    super();
    this.state = {
      plan: upgradePlans[0],
      promo: {
        code: "",
        valid: null,
      },
      showPromoBox: false,
    };

    this.promoEntered = this.promoEntered.bind(this);
    this.inputTimeout = null;
  }

  handSubmit(e) {
    e.preventDefault();
  }

  promoEntered(value) {
    clearTimeout(this.inputTimeout);

    if (value.length < 4) {
      return;
    }

    var that = this;
    this.inputTimeout = setTimeout(function () {
      let code = value;

      /**
       * check the validity of the code with the API and apply discount if acceptable
       */
      Api.checkPromo(
        that.props.userApiRequest,
        { code },
        {
          onSuccess: ({ data }) => {
            that.setState({
              promo: {
                code,
                valid: data.valid,
              },
            });
          },
          onError: (e) => {
            that.setState({
              promo: {
                code,
                valid: false,
              },
            });
          },
        }
      );
    }, 300);
  }

  handSubmitOptionSelect(selectedOption) {
    this.setState({
      plan: selectedOption,
    });
  }

  componentDidMount() {
    const { account_type } = AppAuthStore.getSessionUserData();

    if (!account_type) {
      return browserHistory.push(window.location.pathname);
    }

    // the page it opened over shows where the upgrade prompt came from
    Analytics.event('view_upgrade', { from_path: window.location.pathname });

    this.setState({
      plan: upgradePlans.find((x) => x.type === account_type),
    });
  }

  renderSummary() {
    const freeAccount = this.state.plan.type === "Starter";
    const { account_type, is_academic } = AppAuthStore.getSessionUserData();
    const { promo, plan } = this.state;

    if (freeAccount || account_type === plan.type) {
      return null;
    }

    const recurrence = plan.recurrence ? "/" + plan.recurrence : "";
    const discounted = is_academic && Boolean(plan.discount_price);
    const price = discounted ? (
      <span className="upgrade-price">
        <span className="upgrade-price-strike">&pound;{plan.price}</span>
        <span className="upgrade-price-active">&pound;{plan.discount_price}{recurrence}</span>
      </span>
    ) : (
      <span className="upgrade-price">
        <span className="upgrade-price-active">&pound;{plan.price}{recurrence}</span>
      </span>
    );

    return (
      <div className="upgrade-summary">
        <div className="upgrade-summary-row">
          <div className="upgrade-summary-label">
            You will be charged
            {promo.valid ? <span className="upgrade-summary-note"> after the first 12 months</span> : null}
          </div>
          {price}
        </div>
        <PaymentButton
          {...this.props}
          selectedPlan={plan}
          promoCode={promo.valid ? promo.code : ''}
          amount={discounted ? plan.discount_price : plan.price}
        />
        <p className="upgrade-summary-legals">
          By paying via PayPal, Neurochecklists will set up renewal payments for your convenience.
        </p>
      </div>
    );
  }

  renderUpgradeOptions() {
    const { account_type, free_trial_expired, free_trial_expires_at } = AppAuthStore.getSessionUserData();
    const { promo } = this.state;

    let plans = promo.valid ? upgradePlans.filter(p => p.plan_id === 'yearly_premium' ) : upgradePlans;

    return (
      <div className="plan-list">
        {plans.map((plan) => {
          const currentAccount = account_type === plan.type;
          const isSelected = this.state.plan.type === plan.type;
          const isFreePlan = plan.price === false || plan.price < 1;

          const planDescription = isFreePlan
            ? (free_trial_expired ? 'Free trial · Expired' : `Free trial · Until ${moment(free_trial_expires_at).format('D MMMM, YYYY')}`)
            : plan.searches;

          let badge = null;
          if (currentAccount) {
            badge = <span className="plan-badge plan-badge-current">Current Plan</span>;
          } else if (isSelected && plan.type !== 'Starter') {
            badge = <span className="plan-badge plan-badge-selected">Selected</span>;
          }

          return (
            <div
              key={plan.type}
              className={classnames({ 'plan-option': true, 'plan-option-selected': isSelected, 'plan-option-current': currentAccount })}
              onClick={this.handSubmitOptionSelect.bind(this, plan)}
            >
              <input
                type="radio"
                name="plan"
                id={plan.id}
                value={plan.type}
                onChange={() => {}}
                checked={isSelected}
              />
              <label htmlFor={plan.id} className="plan-option-label">
                <div className="plan-radio-dot" aria-hidden="true"></div>
                <div className="plan-info">
                  <div className="plan-name">
                    {plan.type === 'Starter' ? 'Free Trial' : plan.type}
                    {badge}
                  </div>
                  <div className="plan-desc">{planDescription}</div>
                  {plan.saving ? <div className="plan-saving">{plan.saving}</div> : null}
                </div>
                <div className="plan-price-col">
                  {plan.price !== false ? (
                    <span className="plan-price-amount">
                      &pound;{plan.price}
                      {plan.abbreviation ? <span className="plan-price-period">/{plan.abbreviation}</span> : null}
                    </span>
                  ) : (
                    <span className="plan-price-amount plan-price-free">Free</span>
                  )}
                </div>
              </label>
            </div>
          );
        })}
      </div>
    );
  }

  renderPromoCode() {
    const { promo, showPromoBox, plan } = this.state;

    if (plan.id == "starter") {
      return null;
    }

    return (
      <div className="promo-section">
        {!showPromoBox ? (
          <button
            type="button"
            className="promo-toggle"
            onClick={() => this.setState({ showPromoBox: true })}
          >
            Have a promo code?
          </button>
        ) : (
          <div className="promo-input-wrap">
            <label htmlFor="promo-code-input" className="promo-label">Enter promo code</label>
            <input
              id="promo-code-input"
              type="text"
              defaultValue={promo.code}
              className={classnames({
                "promo-input": true,
                success: promo.code && promo.valid,
                error: promo.code && !promo.valid,
              })}
              ref="promo"
              onChange={(e) => this.promoEntered(e.target.value)}
              placeholder="Enter code"
            />
          </div>
        )}
      </div>
    );
  }

  render() {
    const { is_academic } = AppAuthStore.getSessionUserData();

    return (
      <form onSubmit={this.handSubmit} className="upgrade-modal-form">
        <div className="modal-body">
          <ModalHeader
            title="Upgrade to a premium account"
            sub={is_academic ? 'You are eligible for an educational discount' : 'Choose the plan that works best for you'}
          />

          {this.renderUpgradeOptions()}
          {this.renderSummary()}
          {this.renderPromoCode()}
        </div>
      </form>
    );
  }
}

export default withRouter(authenticationMixin(UpgradeModal));
